// extracted by mini-css-extract-plugin
export default {"vipContainer":"style_vipContainer__fsDjN","title":"style_title__KBtVV","copy":"style_copy__JPBYM"};